import { render, staticRenderFns } from "./GrcDialogPayment_SimpleV2.vue?vue&type=template&id=d4276c12&"
import script from "./GrcDialogPayment_SimpleV2.vue?vue&type=script&lang=js&"
export * from "./GrcDialogPayment_SimpleV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports